import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
 */
import React from 'react';
import { PageContextConsumer } from './PageContext';

var withPageContext = function withPageContext(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(PageContextConsumer, null, function (contextProps) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, contextProps));
    });
  };
};

export default withPageContext;